<template>
    <div class="row">
        <div class="col-md-6">
            <table class="table table-striped table-bordered text-nowrap">
                <thead class="thead-dark">
                <tr>
                    <th>{{$t("agencia")}}</th>
                    <th>{{$t("importe")}}</th>
                    <th>{{$t("comision")}}</th>
                    <th>{{$t("descuento")}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="agencia in agencias">
                    <td>{{agencia.name}}</td>
                    <td>{{agencia.amount|currency}}</td>
                    <td>{{agencia.comision|currency}}</td>
                    <td>{{agencia.dto|currency}}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr class="table-success">
                    <td>{{$t("total")}}</td>
                    <td>{{getTotalImporte|currency}}</td>
                    <td>{{getTotalComision|currency}}</td>
                    <td>{{getTotalDescuento|currency}}</td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        created() {
            this.getIncidencias();
        },

        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        props: ['idBusiness', 'idDay'],
        data() {
            return {
                agencias: []
            }
        },
        computed: {
            getTotalImporte() {
                let importe = 0;
                this.agencias.forEach(function (d) {
                    importe += d.amount;
                });
                return importe;
            },
            getTotalComision() {
                let comision = 0;
                this.agencias.forEach(function (d) {
                    comision += d.comision;
                });
                return comision;
            },
            getTotalDescuento() {
                let dto = 0;
                this.agencias.forEach(function (d) {
                    dto += d.dto;
                });
                return dto;
            },
        },
        methods: {

            getIncidencias() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idDay: this.idDay,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "sales/getVentasAgenciasOfDay", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.agencias = response.data.result;
                        }
                        else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.result,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }
                        vm.loading = false;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


        }


    }
</script>

<style scoped>
    tfoot td{
        font-weight: bold;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/Widgets/Agencias.vue